module.exports = __webpack_public_path__ + "static/media/SugaryDrinks – 1.776405d6.jpg";